import { LoadingButton, Card, CardContent, CardHeader } from "@bvhi/ui-base";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAppConfig } from "../../../../../../config/config";
import { useDownload } from "../../../../../../hooks/use-download";
import { DownloadIcon } from "@bvhi/ui-icons";
import { useToast } from "../../../../../../hooks/use-toast";

export const UsersMarketingConsentCard = () => {
  const { t } = useTranslation(["users", "toasts"]);
  const { fetchFileAndDownload } = useDownload();
  const { pushCustomErrorToast, pushCustomSuccessToast } = useToast();

  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const downloadMarketingConsentFile = useCallback(() => {
    void (async () => {
      setIsDownloading(true);
      try {
        await fetchFileAndDownload(`${getAppConfig().env.baseUrl}/gateway/platform/v1/users/marketing-consent`);
        pushCustomSuccessToast(t("toasts:toasts.download.success"));
      } catch (error) {
        console.error("Download failed:", error);
        pushCustomErrorToast(t("toasts:toasts.download.error"));
      } finally {
        setIsDownloading(false);
      }
    })();
  }, [fetchFileAndDownload, pushCustomSuccessToast, pushCustomErrorToast, t]);

  return (
    <Card>
      <CardHeader subheader={t("users:users.card.marketing-consent.text")} title={t("users:users.card.marketing-consent.title")} />
      <CardContent>
        <LoadingButton loading={isDownloading} onClick={downloadMarketingConsentFile} startIcon={<DownloadIcon />}>
          {t("users:users.card.marketing-consent.button")}
        </LoadingButton>
      </CardContent>
    </Card>
  );
};
